import React from 'react'

export default props => (
    <td {...props} align={props.alignRight ? 'right' : (props.alignCenter ? 'center' : 'left')}>
		{props.children}
	</td>
)
